import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./services/i18n";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import { initCore } from "@sequentech/ui-core";
import AuthContextProvider from "./providers/AuthContextProvider";
import { fullAdminTheme } from "./services/AdminTheme";
import { TenantContextProvider } from "./providers/TenantContextProvider";
import { ElectionEventContextProvider } from "./providers/ElectionEventContextProvider";
import { ElectionContextProvider } from "./providers/ElectionContextProvider";
import { ContestContextProvider } from "./providers/ContestContextProvider";
import { CandidateContextProvider } from "./providers/CandidateContextProvider";
import { ElectionEventTallyContextProvider } from "./providers/ElectionEventTallyProvider";
import NewResourceContextProvider from "./providers/NewResourceProvider";
import { PublishContextProvider } from "./providers/PublishContextProvider";
import { SettingsWrapper } from "./providers/SettingsContextProvider";
import { ApolloContextProvider, ApolloWrapper, defaultApolloContextValues, } from "./providers/ApolloContextProvider";
import { DatabaseProvider } from "./providers/DatabaseProvider";
import { WidgetsContextProvider } from "./providers/WidgetsContextProvider";
import { BrowserRouter as Router } from "react-router-dom";
var root = ReactDOM.createRoot(document.getElementById("root"));
initCore();
root.render(_jsx(React.StrictMode, { children: _jsx(Router, { children: _jsx(SettingsWrapper, { children: _jsx(ThemeProvider, { theme: fullAdminTheme, children: _jsx(AuthContextProvider, { children: _jsx(TenantContextProvider, { children: _jsx(NewResourceContextProvider, { children: _jsx(ElectionEventContextProvider, { children: _jsx(ElectionContextProvider, { children: _jsx(ContestContextProvider, { children: _jsx(CandidateContextProvider, { children: _jsx(ElectionEventTallyContextProvider, { children: _jsx(PublishContextProvider, { children: _jsx(ApolloContextProvider, { role: defaultApolloContextValues.role, children: _jsx(ApolloWrapper, { children: _jsx(DatabaseProvider, { children: _jsx(WidgetsContextProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }) }) }) }) }) }) }) }) }) }) }));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
